import React from 'react';
import PropTypes from 'prop-types';
import { RootProvider, useI18n } from '@jarvis/react-portal-addons';
import { Body, Container, Header } from './styles';
import resources from '../../../assets/locale/index';

const TouPageContent = () => {
  const { t } = useI18n();

  return (
    <Container data-testid="tou-page">
      <Header
        className="title-regular"
        data-testid="tou-page-title"
      >
        {t('tou.page.title')}
      </Header>
      <Body
        dangerouslySetInnerHTML={{ __html: t('tou.page.body') }}
        data-testid="tou-page-body"
      />
    </Container>
  );
};

const TouPage = ({ shell, stack }) => {
  const localization = shell?.localization || {};

  return (
    <RootProvider
      localization={localization}
      shell={shell}
      stack={stack}
      resources={resources}
    >
      <TouPageContent />
    </RootProvider>
  );
};

TouPage.defaultProps = {
  shell: {},
  stack: undefined,
};

TouPage.propTypes = {
  shell: PropTypes.objectOf(PropTypes.any),
  stack: PropTypes.string,
};

export default TouPage;
